import { useTranslation } from 'react-i18next';
import { useParams, Switch, Route } from 'react-router-dom';
import { CatalogOnlineSourcePages } from './Pages';
import { CatalogOnlineSourcesList } from './Sources';
import { StyledSubNavigation, NavWrapper } from './styles';

export const CatalogOnlineSources = () => {
  const { t } = useTranslation();
  const { catalogId } = useParams<{ catalogId: string }>();

  const basePath = `/knowledge/${catalogId}/online-sources`;

  const subRoutes = {
    sources: { path: basePath, label: t('Sources'), exact: true },
    pages: { path: `${basePath}/pages`, label: t('Pages') },
  };

  return (
    <>
      <NavWrapper>
        <StyledSubNavigation routes={subRoutes} small />
      </NavWrapper>
      <Switch>
        <Route
          exact
          path="/knowledge/:catalogId/online-sources/pages"
          render={() => <CatalogOnlineSourcePages />}
        />
        <Route render={() => <CatalogOnlineSourcesList />} />
      </Switch>
    </>
  );
};
